import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "sp-checkbox"
    }}>{`sp-checkbox`}</h1>
    <p><strong parentName="p">{`Since:`}</strong>{` UXP v4.1`}</p>
    <p>{`Renders a checkbox with associated label.`}</p>
    <p><img alt="Checkboxes" src={require("../../assets/sp-checkbox.png")} /></p>
    <p><strong parentName="p">{`See`}</strong>{`:`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://spectrum.adobe.com/page/checkbox/"
        }}>{`https://spectrum.adobe.com/page/checkbox/`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://opensource.adobe.com/spectrum-web-components/components/checkbox"
        }}>{`https://opensource.adobe.com/spectrum-web-components/components/checkbox`}</a></li>
    </ul>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-html"
      }}>{`<sp-checkbox>Include all metadata</sp-checkbox>
`}</code></pre>
    <h2 {...{
      "id": "states"
    }}>{`States`}</h2>
    <p>{`There are several states that are supported.`}</p>
    <h3 {...{
      "id": "checked"
    }}>{`Checked`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-html"
      }}>{`<sp-checkbox checked>Checked</sp-checkbox>
`}</code></pre>
    <h3 {...{
      "id": "indeterminate"
    }}>{`Indeterminate`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-html"
      }}>{`<sp-checkbox indeterminate>Indeterminate</sp-checkbox>
`}</code></pre>
    <h3 {...{
      "id": "disabled"
    }}>{`Disabled`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-html"
      }}>{`<sp-checkbox disabled>Disabled</sp-checkbox>
`}</code></pre>
    <h3 {...{
      "id": "invalid"
    }}>{`Invalid`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-html"
      }}>{`<sp-checkbox invalid>Invalid</sp-checkbox>
`}</code></pre>
    <h2 {...{
      "id": "responding-to-events"
    }}>{`Responding to events`}</h2>
    <p>{`You can respond to changes in the checkbox using the `}<inlineCode parentName="p">{`change`}</inlineCode>{` or `}<inlineCode parentName="p">{`input`}</inlineCode>{` events.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`document.querySelector(".yourCheckbox").addEventListener("change", evt => {
    console.log(\`Is the checkbox checked: \${evt.target.checked}\`);
})
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      